export default "__VITE_ASSET__5133f134__"